// Multivariate Dependencies
import React, { memo } from 'react';
// Components
import Icon from '../Icons/Icon';
// Utils
import { classNames } from 'ezyvet-fe-helpers';
/**
 * @deprecated Do not use legacy components anymore.
 */
var Button = function (props) {
    var disabled = props.disabled, wrapperClass = props.wrapperClass, buttonClasses = props.buttonClasses, style = props.style, showText = props.showText, icon = props.icon, action = props.action, buttonText = props.buttonText, titleText = props.titleText, elementId = props.elementId;
    var buttonWrapperClasses = classNames('buttonHolder', 'react', { disabledButton: disabled }, { clickable: !disabled }, wrapperClass);
    return (React.createElement("div", { className: buttonWrapperClasses, style: style, onClick: disabled ? function () { return false; } : action, onKeyDown: function () { return false; }, role: 'button', tabIndex: -1 },
        React.createElement("div", { "data-testid": elementId, title: titleText !== null && titleText !== void 0 ? titleText : buttonText, className: classNames('innerButton', buttonClasses) },
            icon && React.createElement(Icon, { icon: icon }),
            showText && React.createElement("span", { className: 'buttonText' }, buttonText))));
};
Button.defaultProps = {
    action: function () { return false; },
    disabled: false,
    showText: false,
    buttonText: '',
    wrapperClass: '',
    style: {},
    buttonClasses: {},
    elementId: '',
};
export default memo(Button);
//# sourceMappingURL=Button.js.map